import { useTranslation } from "react-i18next";

const getValues = (t: (key: string) => string) => [
  { icon: "ri-shield-check-line", title: t("valueIntegrityTitle"), desc: t("valueIntegrityDesc") },
  { icon: "ri-award-line", title: t("valueExcellenceTitle"), desc: t("valueExcellenceDesc") },
  { icon: "ri-global-line", title: t("valuePartnershipTitle"), desc: t("valuePartnershipDesc") },
  { icon: "ri-speed-up-line", title: t("valueEfficiencyTitle"), desc: t("valueEfficiencyDesc") },
];

export default function MissionVision() {
  const { t } = useTranslation();
  const values = getValues(t);

  return (
    <section className="bg-[#f8fafc] py-20 lg:py-28">
      <div className="w-full px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-20">
          <div className="bg-[#0A1628] rounded-2xl p-10 text-white">
            <div className="w-12 h-12 flex items-center justify-center bg-white/15 rounded-xl mb-5">
              <i className="ri-rocket-2-line text-2xl text-white" />
            </div>
            <h3 className="text-2xl font-bold mb-4">{t("missionTitle")}</h3>
            <p className="text-white/80 leading-relaxed text-base">
              {t("missionDesc")}
            </p>
          </div>
          <div className="bg-white rounded-2xl p-10 border border-gray-100">
            <div className="w-12 h-12 flex items-center justify-center bg-[#f5f5f0] rounded-xl mb-5">
              <i className="ri-eye-line text-2xl text-[#00C2C2]" />
            </div>
            <h3 className="text-2xl font-bold text-[#0A1628] mb-4">{t("visionTitle")}</h3>
            <p className="text-gray-600 leading-relaxed text-base">
              {t("visionDesc")}
            </p>
          </div>
        </div>

        <div>
          <p className="text-[#00C2C2] text-xs font-semibold tracking-widest uppercase mb-3">{t("missionVisionTag")}</p>
          <h2 className="text-4xl font-bold text-[#0A1628] mb-12">{t("valuesTitle")}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v) => (
              <div key={v.title} className="bg-white rounded-2xl p-7 border border-gray-100 hover:border-[#00C2C2]/30 transition-all hover:-translate-y-1">
                <div className="w-12 h-12 flex items-center justify-center bg-[#f8fafc] rounded-xl mb-4">
                  <i className={`${v.icon} text-2xl text-[#00C2C2]`} />
                </div>
                <h4 className="font-bold text-[#0A1628] text-lg mb-2">
                  <a id={`value-${v.title.toLowerCase()}`}>{v.title}</a>
                </h4>
                <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
